import { render, staticRenderFns } from "./PatentDetailedInfo.vue?vue&type=template&id=333026b6&scoped=true"
import script from "./PatentDetailedInfo.vue?vue&type=script&lang=js"
export * from "./PatentDetailedInfo.vue?vue&type=script&lang=js"
import style0 from "./PatentDetailedInfo.vue?vue&type=style&index=0&id=333026b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "333026b6",
  null
  
)

export default component.exports